<common-ui-nachreichung [(data)]="data" [readonly]="readonly"></common-ui-nachreichung>
